const Footer = () => {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1a2b4a] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <img
              src="https://static.readdy.ai/image/1b7d8ba0d33546c92bdd2a3ada1e3e7c/f709ae3db271d6c0d8bf92ab254501ef.png"
              alt="PAC KOREA 전립상회 로고"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              박문수 원장이 직접 설계한 프로엑티브 시리즈. 프로엑티브케어 식단과 최적 조합 건강기능식품.
            </p>
            <div className="flex gap-3">
              {[
                { icon: 'ri-instagram-line', label: '인스타그램' },
                { icon: 'ri-kakao-talk-fill', label: '카카오톡' },
                { icon: 'ri-youtube-line', label: '유튜브' },
              ].map((s, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 text-white/60 hover:bg-white/20 hover:text-white transition-colors duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-sm font-bold mb-5 text-white">
              <a href="#products" onClick={(e) => { e.preventDefault(); scrollTo('products'); }}>제품</a>
            </h4>
            <ul className="flex flex-col gap-3">
              {['프로엑티브 듀오', '프로엑티브 오메가3', '프로엑티브 릴랙스', '에이치씨에이 플러스'].map((item) => (
                <li key={item}>
                  <a
                    href="#products"
                    onClick={(e) => { e.preventDefault(); scrollTo('products'); }}
                    className="text-white/50 text-sm hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>



          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold mb-5 text-white">연락처</h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-white/40 text-sm mt-0.5 flex-shrink-0" />
                <span className="text-white/50 text-sm leading-relaxed">서울 강남구 선릉로 513<br />APEX 타워 3층</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-white/40 text-sm flex-shrink-0" />
                <span className="text-white/50 text-sm">070-4312-4090</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-white/40 text-sm flex-shrink-0" />
                <span className="text-white/50 text-sm">02-556-4090</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-white/40 text-sm flex-shrink-0" />
                <span className="text-white/50 text-sm">평일 09:00 - 18:00</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Certification Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-wrap items-center justify-center gap-3">
          {[
            { icon: 'ri-shield-check-line', label: 'HACCP 인증' },
            { icon: 'ri-medal-line', label: 'GMP 인증' },
            { icon: 'ri-government-line', label: '식약처 인증' },
            { icon: 'ri-award-line', label: 'ISO 인증' },
            { icon: 'ri-trophy-line', label: '2024 소비자평가 우수상' },
          ].map((cert, i) => (
            <div key={i} className="flex items-center gap-1.5 bg-white/5 border border-white/10 rounded-full px-3.5 py-1.5">
              <i className={`${cert.icon} text-[#d4a843] text-xs`} />
              <span className="text-white/50 text-xs font-medium whitespace-nowrap">{cert.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            &copy; 2026 전립상회 PAC KOREA. All rights reserved.
          </p>
          <div className="flex gap-5">
            {['개인정보처리방침', '이용약관'].map((item) => (
              <a key={item} href="#" className="text-white/40 text-xs hover:text-white/70 transition-colors duration-200 cursor-pointer">
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
